import { GET_PROMO_SLIDER } from "./actionTypes";
import { GET_PROMO_SLIDER_URL } from "../../configs";
import Axios from "axios";

export const getPromoSlides = (lat, lng, token, user_id) => (dispatch) => {
	Axios.post(GET_PROMO_SLIDER_URL, {
		latitude: lat,
		longitude: lng,
		token: token,
        user_id: user_id
	})
		.then((response) => {
			const promo_slides = response.data;
			return dispatch({ type: GET_PROMO_SLIDER, payload: promo_slides });
		})
		.catch(function(error) {
			console.log(error);
		});
};
